import {
  MapPinIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  DocumentChartBarIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';
import { PulseWaveIcon } from '@/components/icons/PulseWaveIcon';
import type { ProductConfig } from '../registry';

export default {
  slug: 'pulse',
  icon: PulseWaveIcon,
  accentColor: {
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    text: 'text-cyan-400',
  },
  navigation: [
    { name: 'PORTFOLIO', href: '/pulse/portfolio', icon: PulseWaveIcon },
    { name: 'SITES', href: '/pulse/sites', icon: MapPinIcon },
    { name: 'ANALYTICS', href: '/pulse/analytics', icon: ChartBarIcon },
    { name: 'SYSTEMS', href: '/pulse/systems', icon: WrenchScrewdriverIcon },
    { name: 'REPORTS', href: '/pulse/reports', icon: DocumentChartBarIcon },
    { name: 'SETTINGS', href: '/pulse/settings', icon: Cog6ToothIcon },
  ],
  landingPage: '/pulse/portfolio',
} satisfies ProductConfig;
